/**
 * 系统常量
 */
export const PREFIX = 'Fx'

const Constants = {
  // 风险等级配色
  RISK_LEVEL_COLOR: {
    LEVEL1_COLOR: 'rgba(253, 97, 97, 1)',
    LEVEL1_BG_COLOR: 'rgba(253, 97, 97, 0.24)',
    LEVEL2_COLOR: 'rgba(253, 137, 47, 1)',
    LEVEL2_BG_COLOR: 'rgba(253, 137, 47, 0.24)',
    LEVEL3_COLOR: 'rgba(255, 234, 68, 1)',
    LEVEL3_BG_COLOR: 'rgba(255, 234, 68, 0.24)',
    LEVEL4_COLOR: 'rgba(0, 158, 247, 1)',
    LEVEL4_BG_COLOR: 'rgba(0, 158, 247, 0.24)',
  },
}

export { Constants }
